import styled from "@emotion/styled";
import Button from "@mui/material/Button";

/* export const LinkSectionWrapper = styled.div`
	background-color: #f6f8fa;
	margin: 34px 0 70px 0;
	padding: 30px;
`; */

export const LinkSectionHeader = styled.p`
	font-size: 20px;
	line-height: 28px;
	padding-bottom: 14px;
	border-bottom: 1px solid #e1e5ea;
`;

export const LinkSectionBodyWrapper = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: flex-end;
	padding-top: 14px;
`;

export const LinkSectionBodyDescriptionWrapper = styled.div``;

export const LinkSectionBodyDescriptionTitle = styled.p`
	font-size: 16px;
	line-height: 28px;
	margin-bottom: 10px;
`;

export const LinkSectionBodyDescriptionContent = styled.p`
	font-size: 14px;
	line-height: 2rem;
	color: #545351;
`;

//

export const LinkSectionWrapper = styled.div`
	background-color: white;
	border: 1px solid #d7d7d7;
	margin: 34px 0 70px 0;
	padding: 30px;
`;

export const GithubLinkContainer = styled.div`
	display: flex;
`;

export const FoodLensLinkContainer = styled.div`
	width: 50%;
	margin-right: 24px;
`;

export const CaloAILinkContainer = styled.div`
	width: 50%;
`;

export const GithubLinkTitle = styled.div`
	font-size: 20px;
	border-bottom: 2px solid #e1e5ea;
	padding-bottom: 9px;
	display: flex;
`;

export const GithubLinkContents = styled.div`
	padding: 20px 0px;
	font-size: 14px;
	color: #545351;
`;

export const GuideLinkButton = styled(Button)`
	color: inherit;
	border-color: #7e7e7e;
	width: 120px;
	height: 30px;
	margin-right: 7px;
	align-self: center;
	text-transform: none;
	font-weight: bold;
`;
